<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Listas de Precio
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[2000, 5020]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(0)"
				[(ngModel)]="history" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[2000, 5020]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-arrow-right-arrow-left"></i>Asignación de Listas de Precio
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[2000, 5020]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(1)"
				[(ngModel)]="history" [value]="1" checked id="tab2">
			<label for="tab2" [appCheckPermission]="[2000, 5020]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-arrow-right-arrow-left"></i>Consulta de Precio/Costo Productos
			</label>
<!-- 
			<input type="radio" [appCheckPermission]="[2000, 5020]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(2)" name="pcss3t"
				[(ngModel)]="history" [value]="2" id="tab3" class="tab3">
			<label for="tab3" [appCheckPermission]="[2000, 5020]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-book-bookmark"></i>Asociación Ruta Con Destino
			</label> -->

			<input type="radio" [appCheckPermission]="[2000, 5020]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(3)" name="pcss4t"
				[(ngModel)]="history" [value]="3" id="tab4" class="tab4">
			<label for="tab4" [appCheckPermission]="[2000, 5020]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-book-bookmark"></i>Asociación Ubicacion Con Lista de Precio
			</label>

		</div>
		<div class="row" [hidden]="history!=0">
			<div class="col" id="list-container">
				<app-price-list-crud *ngIf="history==0"></app-price-list-crud>
			</div>
		</div>
		<div class="row" [hidden]="history!=1">
			<div class="col" id="list-container">
				<app-cost-list-crud *ngIf="history==1"></app-cost-list-crud>
			</div>
		</div>
		<!-- <div class="row" [hidden]="history!=2">
			<div class="col" id="list-container">
				<app-association-price-list-destination *ngIf="history==2"></app-association-price-list-destination>
			</div>
		</div> -->

		<div class="row" [hidden]="history!=3">
			<div class="col" id="list-container">
				<app-association-price-list-place *ngIf="history==3"></app-association-price-list-place>
			</div>
		</div>
	</div>

</div>